import React from "react";
import { withStyles, ThemeProvider } from "@material-ui/styles";
import {
  CircularProgress,
  Container,
  Grid,
  Typography,
  Paper,
  Button,
} from "@material-ui/core";

import { getCompanyRegionalityInfo } from "../utils";
import * as d3 from "d3";
import CompanyRegionalityViz from "./CompanyRegionalityViz";
import { FiberManualRecord } from "@material-ui/icons";
import { Skeleton as Skelly } from '@material-ui/lab';

var converter = require("number-to-words");

const Skeleton = (props) => {
  return <Skelly animation='wave' {...props} />
}


// const dimension = 340;
const dimension = 240;

const styles = (theme) => ({
  root: {
    margin: "30px 30px",
    width: "100%"
  },
  centerContainer: {
    position: "absolute",
    top: dimension / 2 - 34,
    left: dimension / 2 - 55,
    textAlign: "center",
  },
  viz: {
    position: "relative",
  },
});

const generateDataNetwork = (value, length = 5) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(
        d3.range(length).map((item, index) => ({
          date: index,
          value:
            value === null || value === undefined ? Math.random() * 100 : value,
        }))
      );
    }, 4000);
  });
};

const generateDataSync = (value, length = 5) => {
  let regionNames = [
    "United States",
    "United Kingdom",
    "China",
    "India",
    "Singapore",
  ];
  return d3.range(length).map((item, index) => ({
    region: index,
    regionName: regionNames[index],
    value: value === null || value === undefined ? Math.random() * 100 : value,
  }));
};

class CompanyRegionality extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      error: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  changeData = () => {
    const data = generateDataSync();
    this.setState({
      data: data,
    });
  };

  getData = async () => {
    let data;
    try {
      data = await getCompanyRegionalityInfo(this.props.companyName);
    } catch (e) {
      this.setState({
        error: true,
      });
      return;
    }
    if (!data) {
      this.setState({
        error: true,
      });
      return;
    }
    // const data = await generateDataNetwork();
    data = Object.keys(data).map((k, i) => {
      return {
        region: i,
        regionName: k,
        value: data[k],
      };
    });
    this.setState({
      data: data,
    });
  };

  render() {
    const { classes, loading } = this.props;
    const colors = [
      "#d3eecd",
      "#b7e2b1",
      "#97d494",
      "#73c378",
      "#4daf62",
      "#2f984f",
      "#157f3b",
      "#036429",
      "#00441b",
    ];
    // const Node = document.getElementById("regionality-viz-root")

    // let parentWidth = document.getElementById("regionality-viz-root").parentElement.clientWidth;
    // console.log(parentWidth);
    let data = this.state.data;
    if (!data) {
      data = [{ region: 0, regionName: "", value: 1 }];
    }

    if (loading) {
      return (
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={5}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Skeleton>
                    <Typography variant="h5" gutterBottom style={{ fontFamily: "Arvo"}}>
                      Where do they Live?
                    </Typography>
                  </Skeleton>
                  {this.state.error && (
                    <Skeleton>
                      <Typography variant="body1" style={{ fontFamily: "Lato"}}>
                        There is no data on this company.
                      </Typography>                      
                    </Skeleton>
                  )}
                  {data.length > 1 && (
                    <Typography variant="body1">
                      {this.props.companyName}'s workforce consists of{" "}
                      {this.props.numEmployees} employees, who are primarily
                      distributed among {converter.toWords(data.length)}{" "}
                      countries:
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  {data.length > 1 &&
                    data.map((d, i) => {
                      return (
                        <Grid container alignItems="center">
                          <FiberManualRecord
                            style={{
                              fontSize: 24,
                              color: colors[i],
                              marginRight: "8px",
                            }}
                          />
                          <Typography variant="body1" display="inline">
                            {d.regionName}
                          </Typography>
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={7}>
              <Grid container justify="center">
                <div id="regionality-viz-root" className={classes.viz}>
                  <Skeleton variant="circle">
                    <CompanyRegionalityViz
                      data={data}
                      width={dimension}
                      height={dimension}
                      innerRadius={dimension / 2 - dimension / 6}
                      outerRadius={dimension / 2}
                      colors={colors}
                    />
                  </Skeleton>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>          
      )
    }
    return (
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={5}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom style={{ fontFamily: "Arvo"}}>
                  Where do they Live?
                </Typography>
                {this.state.error && (
                  <Typography variant="body1" style={{ fontFamily: "Lato"}}>
                    There is no data on this company.
                  </Typography>
                )}
                {data.length > 1 && (
                  <Typography variant="body1">
                    {this.props.companyName}'s workforce consists of{" "}
                    {this.props.numEmployees} employees, who are primarily
                    distributed among {converter.toWords(data.length)}{" "}
                    countries:
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12}>
                {data.length > 1 &&
                  data.map((d, i) => {
                    return (
                      <Grid container alignItems="center">
                        <FiberManualRecord
                          style={{
                            fontSize: 24,
                            color: colors[i],
                            marginRight: "8px",
                          }}
                        />
                        <Typography variant="body1" display="inline">
                          {d.regionName}
                        </Typography>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={7}>
            <Grid container justify="center">
              <div id="regionality-viz-root" className={classes.viz}>
                <CompanyRegionalityViz
                  data={data}
                  width={dimension}
                  height={dimension}
                  innerRadius={dimension / 2 - dimension / 6}
                  outerRadius={dimension / 2}
                  colors={colors}
                />
                <div className={classes.centerContainer}>
                  <Typography variant="h6" align="center">
                    # Employees
                  </Typography>
                  <Typography variant="h5" align="center">
                    {this.props.numEmployees}
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(CompanyRegionality);
